<form [formGroup]="clientCompanyForm" (ngSubmit)="onSubmit()" class="grid gap-4 pt-2">
  <mat-form-field class="w-full">
    <mat-label>Company</mat-label>
    <mat-select formControlName="companyId">
      @for (company of companies(); track company.id) {
        <mat-option [value]="company.id">{{ company.name }}</mat-option>
      }
    </mat-select>
    @if (clientCompanyForm.get('companyId')?.hasError('required')) {
      <mat-error>Company is required</mat-error>
    }
  </mat-form-field>

  <mat-form-field class="w-full">
    <mat-label>Unique company code</mat-label>
    <input matInput formControlName="uniqueCompanyCode" type="text" />
    @if (clientCompanyForm.get('uniqueCompanyCode')?.hasError('required')) {
      <mat-error>Unique company code is required</mat-error>
    }
  </mat-form-field>

  <mat-form-field class="w-full">
    <mat-label>Company client code</mat-label>
    <input matInput formControlName="companyClientCode" type="text" />
  </mat-form-field>

  <button mat-raised-button color="primary" type="submit" [disabled]="clientCompanyForm.invalid || saving()">
    Save
  </button>
</form>